// may need to check the tepual icons again

// "Andimar" sliding images

import CommonService from '../../../../services/commonService';
import aeroquintaSlides from './aeroquintaSlides';
import andimarBannerSlide1 from '../../assets/andimar/slider/slide1.jpg';
import andimarBannerSlide2 from '../../assets/andimar/slider/slide2.jpg';
import andimarBannerSlide3 from '../../assets/andimar/slider/slide3.jpg';
import andimarDestinationSlide1 from '../../assets/andimar/destinations/santiago.png';
import andimarDestinationSlide2 from '../../assets/andimar/destinations/vallenar.png';
import andimarDestinationSlide3 from '../../assets/andimar/destinations/antofagasta.png';
import andimarDestinationSlide4 from '../../assets/andimar/destinations/copiapo.png';
import andimarDestinationSlide5 from '../../assets/andimar/destinations/curico.png';
import andimarDestinationSlide6 from '../../assets/andimar/destinations/ovalle.png';
import andimarDestinationSlide7 from '../../assets/andimar/destinations/sanfernando.png';
import andimarDestinationSlide8 from '../../assets/andimar/destinations/santacruz.png';
// import andimarDestinationSlide9 from '../../assets/andimar/destinations/temuco.png';
import andimarDestinationSlide9 from '../../assets/andimar/destinations/Calama-Destination.jpg';
import andimarFleetSlide1 from '../../assets/andimar/fleet/2.jpg';
import andimarFleetSlide10 from '../../assets/andimar/fleet/11.jpg';
import andimarFleetSlide11 from '../../assets/andimar/fleet/12.jpg';
import andimarFleetSlide12 from '../../assets/andimar/fleet/13.jpg';
import andimarFleetSlide13 from '../../assets/andimar/fleet/14.jpg';
import andimarFleetSlide14 from '../../assets/andimar/fleet/15.jpg';
import andimarFleetSlide15 from '../../assets/andimar/fleet/16.jpg';
import andimarFleetSlide16 from '../../assets/andimar/fleet/17.jpg';
import andimarFleetSlide2 from '../../assets/andimar/fleet/3.jpg';
import andimarFleetSlide3 from '../../assets/andimar/fleet/4.jpg';
import andimarFleetSlide4 from '../../assets/andimar/fleet/5.jpg';
import andimarFleetSlide5 from '../../assets/andimar/fleet/6.jpg';
import andimarFleetSlide6 from '../../assets/andimar/fleet/7.jpg';
import andimarFleetSlide7 from '../../assets/andimar/fleet/8.jpg';
import andimarFleetSlide8 from '../../assets/andimar/fleet/9.jpg';
import andimarFleetSlide9 from '../../assets/andimar/fleet/10.jpg';
import arzolaSlides from './arzolaSlides';
import bahiaazulSlides from './bahiaazulSlides';
import biagginiSlides from './biagginiSlides';
import busesJmSlides from './busesJmSlides';
import busesahumadaSlides from './busesahumadaSlides';
import busesbarriaSlides from './busesbarriaSlides';
import busnorteSlides from './busnorteSlides';
import centralTourSlides from './centralTourSlides';
import centropuertoSlides from './centropuertoSlides';
import chilebusSlides from './chilebusSlides';
import combarbalaSlides from './combarbalaSlides';
import cormarbusSlides from './cormarbusSlides';
import erbucSlides from './erbucSlides';
import expresoSantaCruzSlides from './exoresosanatacruzSlides';
import expresonorteSlides from './expresonorteSlides';
import fernandezSlides from './fernandezSlides';
import ivergramaSlides from './ivergramaSlides';
import jeldresSlides from './jeldresSlides';
import jetsurSlides from './jetsurSlides';
import kennybusSlides from './kennybusSlides';
import lafitSlides from './lafitSlides';
import lineaazulSlides from './lineaazulSlides';
import liquineSlides from './liquineSlides';
import navegadoresSlides from './navegadoresSlides';
import pullmandelsurSlides from './pullmandelsurSlides';
import pullmansanandresSlides from './pullmanSanAndreas';
import sanantonioSlides from './sanantonioSlides';
import santajuanaSlides from './santajuanaSlides';
import santamariaSlides from './santamariaSlides';
import santarosaSlides from './santarosaSlides';
import saopauloSlides from './saopauloSlides';
import serenamarSlides from './serenamarSlides';
import tacohaSlides from './tacohaSlides';
import tarapacaSlides from './tarapacaSlides';
import tepualSlides from './tepualSlides';
import thaebusSlides from './thaebusSlides';
import torresSlides from './torresSlides';
import travelturSlides from './travelturSlides';
import trrassSlides from './trrassSlides';
import viaturSlides from './viaturSlides';

const anantonioBannerSlide1 = '/assets/sanantonio/Home/SanAntonio-Website-Home-MainBanner.jpg';
// const anantonioBannerSlide2 = '/assets/sanantonio/Home/SanAntonio-Website-Home-MainBanner.jpg';
// const anantonioBannerSlide3 = '/assets/sanantonio/Home/SanAntonio-Website-Home-MainBanner.jpg';

const slides = {
	// viatur
	viaturDestination: viaturSlides.destination,
	viaturGallery: viaturSlides.gallery,

	// cormarbus
	cormarbusDestination: cormarbusSlides.destination,
	cormarbusGallery: cormarbusSlides.gallery,

	tarapacaDestination: tarapacaSlides.destination,
	tarapacaGallery: tarapacaSlides.gallery,


	// serenamar
	serenamarDestination: serenamarSlides.destination,
	serenamarGallery: serenamarSlides.gallery,

	// kennybus
	kennybusDestination: kennybusSlides.destination,
	jetsurDestination: jetsurSlides.destination,

	// santarosa
	santarosaDestination: santarosaSlides.destination,
	santarosaDestination: santarosaSlides.destination,
	santarosaRecomendations: santarosaSlides.recomendations,

	//lineaazul

	lineaazulDestination: lineaazulSlides.destination,
	lineaazulGallery: lineaazulSlides.gallery,


	// kennybus
	santamariaDestination: santamariaSlides.destination,
	// jetsurDestination: jetsurSlides.destination,


	buseslafitDestination: lafitSlides.destination,

	// biaggini 
	biagginiDestination: biagginiSlides.destination,

	//combarbala
	combarbalaDestination: combarbalaSlides.destination,

	//expresosantacruz
	expresosantacruzDestination: expresoSantaCruzSlides.destination,

	// Andimar
	andimarBanner: [andimarBannerSlide1, andimarBannerSlide2, andimarBannerSlide3],



	andimarDestination: [
		andimarDestinationSlide1,
		andimarDestinationSlide2,
		andimarDestinationSlide3,
		andimarDestinationSlide4,
		andimarDestinationSlide5,
		andimarDestinationSlide6,
		andimarDestinationSlide7,
		andimarDestinationSlide8,
		andimarDestinationSlide9,
	],
	andimarFleet: [
		andimarFleetSlide1,
		andimarFleetSlide2,
		andimarFleetSlide3,
		andimarFleetSlide4,
		andimarFleetSlide5,
		andimarFleetSlide6,
		andimarFleetSlide7,
		andimarFleetSlide8,
		andimarFleetSlide9,
		andimarFleetSlide10,
		andimarFleetSlide11,
		andimarFleetSlide12,
		andimarFleetSlide13,
		andimarFleetSlide14,
		andimarFleetSlide15,
		andimarFleetSlide16,
	],

	// Tepual Operator
	tepualBanner: tepualSlides.banner,
	tepualDestination: tepualSlides.destination,
	tepualGallery: tepualSlides.gallery,

	centraltourBanner: centralTourSlides.banner,
	centraltourDestination: centralTourSlides.destination,
	centraltourGallery: centralTourSlides.gallery,

	trrassBanner: trrassSlides.banner,
	trrassDestination: trrassSlides.destination,
	trrassGallery: trrassSlides.gallery,
	trrassBusologists: trrassSlides.busologists,

	// jeldres Operator
	jeldresBanner: jeldresSlides.banner,
	jeldresDestination: jeldresSlides.destination,
	jeldresGallery: jeldresSlides.gallery,
	// Saopaulo Operator
	saopauloBanner: saopauloSlides.banner,
	saopauloDestination: saopauloSlides.destination,


	// navegadores Operator
	losnavegadoresBanner: navegadoresSlides.banner,
	losnavegadoresDestination: navegadoresSlides.destination,





	santajuanaBanner: santajuanaSlides.banner,
	santajuanaDestination: santajuanaSlides.destination,


	// Saopaulo Operator
	chilebusBanner: chilebusSlides.banner,
	chilebusDestination: chilebusSlides.destination,

	// pullmandelsur
	pullmandelsurBanner: pullmandelsurSlides.banner,
	pullmandelsurDestination: pullmandelsurSlides.destination,
	pullmandelsurParcel: pullmandelsurSlides.parcel,
	// Expreso norte
	expressonorteBanner: expresonorteSlides.banner,
	expressonorteDestination: expresonorteSlides.destination,
	expressonorteGallery: expresonorteSlides.gallery,

	// bahi azul
	// ivergrama

	ivergramaBanner: ivergramaSlides.banner,
	ivergramaDestination: ivergramaSlides.destination,
	ivergramaServices: ivergramaSlides.services,

	//torres
	basetorresBanner: torresSlides.banner,
	basetorresDestination: torresSlides.destination,
	basetorresServices: torresSlides.services,

	//arzola

	arzolaBanner: arzolaSlides.banner,
	arzolaGallery: arzolaSlides.gallery,
	arzolaServices: arzolaSlides.services,


	// aeroquinta
	aeroquintaBanner: aeroquintaSlides.banner,
	aeroquintaDestination: aeroquintaSlides.destination,
	aeroquintaServices: aeroquintaSlides.services,
	aeroquintaGallery: aeroquintaSlides.gallery,

	// norte
	busnorteBanner: busnorteSlides.banner,
	busnorteDestination: busnorteSlides.destination,
	busnorteServices: busnorteSlides.services,
	busnorteGallery: busnorteSlides.gallery,


	//

	bahiaazulBanner: bahiaazulSlides.banner,
	bahiaazulDestination: bahiaazulSlides.destination,
	bahiaazulGallery: bahiaazulSlides.gallery,

	// pullman san andreas
	pullmansanandresBanner: pullmansanandresSlides.banner,
	pullmansanandreshomeSliders: pullmansanandresSlides.homeSliders,
	pullmansanandresComapanies: pullmansanandresSlides.companySlides,
	fernandezBanner: fernandezSlides.banner,
	fernandezDestination: fernandezSlides.destination,
	fernandezGallery: fernandezSlides.gallery,
	erbucBanner: erbucSlides.banner,
	erbucDestination: erbucSlides.destination,
	erbucGallery: erbucSlides.gallery,

	busesjmBanner: busesJmSlides.banner,

	barriaghisoniDestination: busesbarriaSlides.destination,

	busesahumadaBanner: busesahumadaSlides.banner,
	busesahumadaDestination: busesahumadaSlides.destination,
	busesahumadaGallery: busesahumadaSlides.gallery,

	sanantonioBanner: [anantonioBannerSlide1],
	sanantonioDestination: sanantonioSlides.destination,

	travelturBanner: travelturSlides.home,
	travelturDestination: travelturSlides.destination,

	liquineBanner: liquineSlides.banner,
	liquineDestination: liquineSlides.destination,
	liquineAgencyTabs: liquineSlides.AgencyTabs,


	tacohaBanner: tacohaSlides.banner,
	tacohaDestination: tacohaSlides.destination,
	tacohaAgencyTabs: tacohaSlides.AgencyTabs,

	thaebusBanner: thaebusSlides.banner,
	thaebusDestination: thaebusSlides.destination,
	thaebusGallery: thaebusSlides.gallery,

	centropuertoBanner: centropuertoSlides.banner,

};

const getSlides = (type, operator) => {
	operator = operator || CommonService.getLocal('op') || {};
	const name = operator && operator.operator_name ? `${operator.operator_name}${type}` : '';
	let data = slides[name];

	console.log(thaebusSlides, 'thaebusSlides');

	// console.log({ data }, 'data----')
	return data ? data : [];
};

export default getSlides;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/getSlides.js